import React from 'react';
import styled from 'styled-components';
import { Button } from './Button';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: ${props => props.theme.spacing.xl} ${props => props.theme.spacing.lg};
  max-width: 360px;
  margin: 0 auto;
  text-align: center;
`;

const IconWrap = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 48px;
  margin-bottom: ${props => props.theme.spacing.lg};
  opacity: 0.7;
  color: ${props => props.theme.colors.muted};
`;

const Title = styled.p`
  font-size: ${props => props.theme.typography.sizes.medium};
  font-weight: 600;
  color: ${props => props.theme.colors.text};
  margin: 0 0 ${props => props.theme.spacing.sm} 0;
`;

const Description = styled.p`
  font-size: ${props => props.theme.typography.sizes.small};
  color: ${props => props.theme.colors.muted};
  line-height: 1.5;
  margin: 0 0 ${props => props.theme.spacing.lg} 0;
`;

export const EmptyState = ({ icon, title, description, action, theme }) => {
  return (
    <Wrapper theme={theme}>
      {icon && <IconWrap theme={theme}>{icon}</IconWrap>}
      {title && <Title theme={theme}>{title}</Title>}
      {description && <Description theme={theme}>{description}</Description>}
      {action && (
        <Button variant="primary" theme={theme} onClick={action.onClick}>
          {action.label}
        </Button>
      )}
    </Wrapper>
  );
};
